import React from 'react';
import PropTypes from 'prop-types';

function DeliveryOptions(props) {
  const { customClass, cmsMessage } = props;

  return (
    cmsMessage.summary && (
      <div className={`${customClass}__delivery-options`} dangerouslySetInnerHTML={{ __html: cmsMessage.summary }} />
    )
  );
}

DeliveryOptions.propTypes = {
  customClass: PropTypes.string.isRequired,
  cmsMessage: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default DeliveryOptions;
